import React from 'react';

import { CommercialPriceLines } from '../../../../components/Commercial/CommercialPriceLines';
import { useOfferContext } from '../../../../context';
import { getCommercialPriceMain } from '../../../../utils/computedProps/commercial/getCommercialPriceMain';
import { getCommercialPriceSub } from '../../../../utils/computedProps/commercial/getCommercialPriceSub';

export function CommercialPriceContainer() {
  const { offer } = useOfferContext();

  const priceMain = getCommercialPriceMain(offer);
  const priceSub = getCommercialPriceSub(offer);

  return <CommercialPriceLines priceMain={priceMain} priceSub={priceSub} />;
}

CommercialPriceContainer.displayName = 'CommercialPriceContainer';
